import { Giveaway } from '@/models/giveaway'

const DRAFT_KEY = 'load_giveaway'

/**
 * The new-giveaway wizard has to survive a full-page redirect: inviting the
 * Discord bot leaves the app and comes back through /auth/discord/guild. The
 * original stashed the draft with `localStorage.setItem('load_giveaway',
 * JSON.stringify(...))` and read it back with `JSON.parse` — which threw on the
 * literal string "null" it wrote on clear, and produced a plain object where a
 * `Giveaway` was expected.
 */
export function saveDraftGiveaway(giveaway: Giveaway): void {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(giveaway.payload()))
  } catch {
    /* storage unavailable — the draft simply will not survive the round trip */
  }
}

export function loadDraftGiveaway(): Giveaway | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY)
    if (!raw || raw === 'null') return null
    return new Giveaway(JSON.parse(raw))
  } catch {
    return null
  }
}

export function clearDraftGiveaway(): void {
  try {
    localStorage.removeItem(DRAFT_KEY)
  } catch {
    /* nothing to do */
  }
}

const RESUME_KEY = 'jlm:resume-wizard'

/**
 * Connecting an account from inside the wizard leaves the app too. The draft
 * is saved as for the bot invite; this marks that the OAuth callback should
 * reopen the wizard on it rather than just returning to the page.
 */
export function markWizardResume(): void {
  try {
    sessionStorage.setItem(RESUME_KEY, '1')
  } catch {
    /* storage unavailable */
  }
}

export function takeWizardResume(): boolean {
  try {
    const marked = sessionStorage.getItem(RESUME_KEY) === '1'
    sessionStorage.removeItem(RESUME_KEY)
    return marked
  } catch {
    return false
  }
}
